<template>
    <div v-if="model && form">
        <template>
            <rkm-area
                no-margin-top
                title="Filtros"
                type="fieldset"
            >
                <rkm-form
                    ref="Form"
                    show-legend
                >
                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-date-picker
                                :end-validations="validations.periodo"
                                :max-date="maxDate"
                                :min-date="minDate"
                                :range-inline="false"
                                :start-validations="validations.periodo"
                                end-label="Até"
                                range
                                start-label="Período de"
                                v-model="model.periodo"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input-autocomplete
                                :repository="repositories.relatorioSolicitacoes.usuarioSolicitante"
                                :requestQueryStringParams="{
                                    periodo: formattedPeriodo,
                                }"
                                :searchFields="fieldsAutocomplete.usuarioSolicitante"
                                :text-field="u => `${u.nomeUsuarioSolicitante}`"
                                @select="usuarioChange()"
                                label="Usuário solicitante"
                                placeholder="Digite o nome do usuário solicitante"
                                uppercase
                                v-model="model.usuarioSolicitanteId"
                                value="id"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-multiselect
                                :options="form.unidades"
                                :validations="validations.unidade"
                                @update:dropdownClosed="unidadeChange()"
                                label="Unidade(s)"
                                optionNameKey="nomeFantasia"
                                optionTextSelecteds="unidade selecionada"
                                show-default-option
                                v-model="model.unidadesId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-multiselect
                                :options="form.infraestruturas"
                                :validations="validations.infraestrutura"
                                @update:dropdownClosed="infraestruturaChange()"
                                label="Local(is) de atendimento"
                                optionNameKey="nome"
                                optionTextSelecteds="infraestrutura selecionada"
                                show-default-option
                                v-model="model.infraestruturasId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-multiselect
                                :options="form.grupos"
                                :validations="validations.grupo"
                                @update:dropdownClosed="grupoChange()"
                                label="Grupo(s)"
                                optionNameKey="nome"
                                optionTextSelecteds="grupo selecionado"
                                show-default-option
                                v-model="model.gruposId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-multiselect
                                :options="form.subgrupos"
                                :validations="validations.subgrupo"
                                @update:dropdownClosed="subgrupoChange()"
                                label="Subgrupo(s)"
                                optionNameKey="nome"
                                optionTextSelecteds="subgrupo selecionado"
                                show-default-option
                                v-model="model.subgruposId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-multiselect
                                :options="form.servicos"
                                :validations="validations.servico"
                                @update:dropdownClosed="servicoChange()"
                                label="Serviço(s)"
                                optionNameKey="nome"
                                optionTextSelecteds="serviço selecionado"
                                show-default-option
                                v-model="model.servicosId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-multiselect
                                :options="form.status"
                                :validations="validations.status"
                                @update:dropdownClosed="statusChange()"
                                label="Status"
                                optionNameKey="nome"
                                optionTextSelecteds="status selecionado"
                                show-default-option
                                v-model="model.statusId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-multiselect
                                :options="form.prioridades"
                                :validations="validations.prioridade"
                                label="Prioridade(s)"
                                optionNameKey="nome"
                                optionTextSelecteds="prioridade selecionado"
                                show-default-option
                                v-model="model.prioridadesId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-button
                                :label="false"
                                @click="handleBuscar()"
                                color="primary"
                            >
                                Buscar
                            </rkm-button>

                            <rkm-button
                                :label="false"
                                @click="reset"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-form>
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-dropdown
                        class="mr-2"
                        color="primary"
                        cols="1"
                        menu-class="auto-scroll"
                        no-caret
                        small
                        title="Colunas"
                        v-rkm-tooltip.hover
                    >
                        <template v-slot:button-content>
                            <rkm-icon icon="columns" />
                        </template>

                        <rkm-form-checkbox
                            :indeterminate="indeterminate"
                            @change="handleSelectedColumns"
                            class="mx-2"
                        >
                            Todas
                        </rkm-form-checkbox>

                        <rkm-form-checkbox-group
                            :options="cols"
                            class="mx-2"
                            stacked
                            v-model="selectedCols"
                        />
                    </rkm-dropdown>

                    <rkm-button
                        :disabled="items.length === 0"
                        @click="print()"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        :disabled="items.length === 0"
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-table
                    v-if="form"
                    :fields="fields"
                    :items="items"
                    :sort-compare="sortCompare"
                >

                    <template #afterTable v-if="items.length > 0">
                        <rkm-row class="mt-2">
                            <rkm-col
                                cols="auto"
                                class="total"
                            >
                                <strong>
                                    Total de solicitações: {{ totalGeral  }}
                                </strong>
                            </rkm-col>

                            <rkm-col
                                cols="auto"
                                class="text-right"
                            >
                                <strong>
                                    Total em aberto: {{ totalAberto }}
                                </strong>
                            </rkm-col>

                            <rkm-col
                                cols="auto"
                                class="text-right"
                            >
                                <strong>
                                    Total cancelado: {{ totalCancelado }}
                                </strong>
                            </rkm-col>

                            <rkm-col
                                cols="auto"
                                class="text-right"
                            >
                                <strong>
                                   Total finalizado: {{ totalFinalizado }}
                                </strong>
                            </rkm-col>

                            <rkm-col
                                cols="auto"
                                class="text-right"
                            >
                                <strong>
                                    Total reaberto: {{ totalReaberto }}
                                </strong>
                            </rkm-col>

                            <rkm-col
                                cols="auto"
                                class="text-right"
                            >
                                <strong>
                                    Total em atendimento: {{ totalEmAtendimento }}
                                </strong>
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-table>
            </rkm-area>
        </template>
    </div>
</template>

<script>

// Mixins.
import {error, file, repository, stringCase, debounce, object, data} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
                unidade: {required: false},
                infraestrutura: {required: false},
                grupo: {required: false},
                subgrupo: {required: false},
                servico: {required: false},
                status: {required: false},
                prioridade: {required: false},
            }
        },
        minDate() {
            const end = this.model.periodo.end
            const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (end != null) {

                return moment(end).subtract(3, 'months').format('DD/MM/YYYY')
            }

            if (this.model.periodo.start == null) {

                return null
            }

            return dataAtual.subtract(3, 'months').format('DD/MM/YYYY')
        },
        maxDate() {
            const start = this.model.periodo.start
            const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (start != null) {

                const end = moment(start).add(3, 'months')

                if (end.isBefore(dataAtual)) {

                    return end.format('DD/MM/YYYY')
                }
            }

            return dataAtual.format('DD/MM/YYYY')
        },
        filters() {
            return this.camelObjectKeysToSnakeRecursive({
                periodo: {
                    start: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                gruposId: this.model.gruposId,
                infraestruturasSolicitantesId: this.model.infraestruturasId,
                prioridadesId: this.model.prioridadesId,
                servicosId: this.model.servicosId,
                statusId: this.model.statusId,
                subgruposId: this.model.subgruposId,
                unidadesSolicitantesId: this.model.unidadesId,
                usuarioSolicitanteId: this.model.usuarioSolicitanteId,
            })
        },
        fieldsAutocomplete() {
            return {
                usuarioSolicitante: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            }
        },
        formattedPeriodo() {
            return {
                start: this.model.periodo.start ? this.others.moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                end: this.model.periodo.end ? this.others.moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
            };
        },
        fields() {
            let fields = [
                {key: 'dataAbertura', label: 'Data de abertura', name: 'data_abertura', sortable: true},
                {key: 'dataFinalizacao', label: 'Data de finalização', name: 'data_finalizacao', sortable: true},
                {key: 'prioridade', label: 'Prioridade', name: 'prioridade.nome', sortable: true},
                {key: 'diasAbertura', label: 'Tempo de atendimento', name: 'dias_abertura', sortable: true},
                {key: 'status', label: 'Status', name: 'parametrizacao_status.nome', sortable: true},
                {key: 'unidade', label: 'Unidade solicitante', name: 'unidade.nome_fantasia', sortable: true},
                {key: 'grupo', label: 'Grupo', name: 'grupo.nome', sortable: true},
                {key: 'servico', label: 'Serviço', name: 'servico.nome', sortable: true},
                {key: 'causasProvaveis', label: 'Causa provável', sortable: true},
            ]

            this.selectedCols.map(column => {

            const col = this.cols.find(find => find.value === column)
                if (col.value !== 'todas') {

                    fields.push({ key: col.value, label: col.text, sortable: true  })
                }
            })

            return fields
        },
        cols() {
            return this.columns
        },
    },
    created() {
        this.repositories = {
            relatorioSolicitacoes: this.getConectaSusRepository('manutencao.relatorioSolicitacoes'),
            impressao: this.getConectaSusRepository('impressao.manutencao'),
            exportacao: this.getConectaSusRepository('exportacao.manutencao'),
        }

        this.load()
    },
    data() {
        return {
            items: [],
            additionals: null,
            form: null,
            model: null,
            others: {moment},
            debounceDelay: 500,
            indeterminate: false,
            selectedCols: [],
            totalGeral: 0,
            totalAberto: 0,
            totalCancelado: 0,
            totalFinalizado: 0,
            totalReaberto: 0,
            totalEmAtendimento: 0,
            loadingCount: 0,
            columns: [
                {
                    value: 'usuarioSolicitante',
                    text: 'Usuário solicitante',
                },
                {
                    value: 'unidadeExecutante',
                    text: 'Unidade executante',
                },
                {
                    value: 'custo',
                    text: 'Custo',
                }
            ],
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'dataAtendimento') {

                const dateA = moment(a[key], 'DD/MM/YYYY')
                const dateB = moment(b[key], 'DD/MM/YYYY')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {
            this.setLoading()

            this.repositories.relatorioSolicitacoes.create()
                .then((response) => {
                    this.additionals = response.data.additionals
                    this.form = response.data.form
                    this.model = response.data.model

                    const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD');

                    this.$set(this.model.periodo, 'start', dataAtual);
                    this.$set(this.model.periodo, 'end', dataAtual);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleBuscar() {
            this.$refs.Form.validate()
                .then(isValid => {
                    if (!isValid) return;

                    this.setLoading()

                    this.items = []

                    this.repositories.relatorioSolicitacoes.index(this.filters)
                        .then(({ data }) => {
                            this.items = data.solicitacoes
                            this.totalGeral = data.totalGeral
                            this.totalAberto = data.solicitacoesStatus.aberto
                            this.totalCancelado = data.solicitacoesStatus.cancelado
                            this.totalFinalizado = data.solicitacoesStatus.finalizado
                            this.totalReaberto = data.solicitacoesStatus.reaberto
                            this.totalEmAtendimento = data.solicitacoesStatus.emAtendimento
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        handleSelectedColumns(selected) {
            if (selected) {

                this.cols.map(col => {

                    this.selectedCols.push(col.value)
                })

            } else {

                this.selectedCols = []
            }
        },
        search() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadesId: this.model.unidadesId,
                infraestruturasId: this.model.infraestruturasId,
                gruposId: this.model.gruposId,
                subgruposId: this.model.subgruposId,
                servicosId: this.model.servicosId,
                statusId: this.model.statusId,
                prioridadesId: this.model.prioridadesId,
            }

            this.setLoading()

            this.repositories.relatorioSolicitacoes.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.model.statusId = null

            this.data = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const printFilter = this.getFilterPrint()

                    this.repositories.impressao.relatorioSolicitacoes(printFilter)
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        exportTo() {
            this.setLoading()

            this.repositories.exportacao.relatorioSolicitacoes(this.getFilterPrint())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        getFilterPrint() {
            const filter = this.getFilter();

            const cols = JSON.parse(JSON.stringify(this.fields)).map(field => {
                field.key = this.camelToSnake(field.key);
                return field;
            });

            filter.columns = cols;

            const profissional = this.model.usuarioSolicitanteId ?? 'Todos';
            filter.usuarioSolicitante = profissional;

            if (this.model.unidadesId.length === 1) {
                const unidade = this.form.unidades.find(u => u.id === this.model.unidadesId[0]);
                filter.unidadeLabel = unidade ? unidade.nomeFantasia : 'Unidade não encontrada';
            } else if (this.model.unidadesId.length > 1 && this.model.unidadesId.length < this.form.unidades.length) {
                filter.unidadeLabel = `${this.model.unidadesId.length} unidades selecionadas`;
            } else {
                filter.unidadeLabel = "Todas";
            }

            if (this.model.infraestruturasId.length === 1) {
                const infraestrutura = this.form.infraestruturas.find(i => i.id === this.model.infraestruturasId[0]);
                filter.infraestruturaLabel = infraestrutura ? infraestrutura.nome : 'Local de atendimento não encontrado';
            } else if (this.model.infraestruturasId.length > 1 && this.model.infraestruturasId.length < this.form.infraestruturas.length) {
                filter.infraestruturaLabel = `${this.model.infraestruturasId.length} locais de atendimento selecionados`;
            } else {
                filter.infraestruturaLabel = "Todos";
            }

            if (this.model.gruposId.length === 1) {
                const grupo = this.form.grupos.find(g => g.id === this.model.gruposId[0]);
                filter.grupoLabel = grupo ? grupo.nome : 'Grupo não encontrado';
            } else if (this.model.gruposId.length > 1 && this.model.gruposId.length < this.form.grupos.length) {
                filter.grupoLabel = `${this.model.gruposId.length} grupos selecionados`;
            } else {
                filter.grupoLabel = "Todos";
            }

            if (this.model.subgruposId.length === 1) {
                const subgrupo = this.form.subgrupos.find(s => s.id === this.model.subgruposId[0]);
                filter.subgrupoLabel = subgrupo ? subgrupo.nome : 'Subgrupo não encontrado';
            } else if (this.model.subgruposId.length > 1 && this.model.subgruposId.length < this.form.subgrupos.length) {
                filter.subgrupoLabel = `${this.model.subgruposId.length} subgrupos selecionados`;
            } else {
                filter.subgrupoLabel = "Todos";
            }

            if (this.model.servicosId.length === 1) {
                const servico = this.form.servicos.find(s => s.id === this.model.servicosId[0]);
                filter.servicoLabel = servico ? servico.nome : 'Serviço não encontrado';
            } else if (this.model.servicosId.length > 1 && this.model.servicosId.length < this.form.servicos.length) {
                filter.servicoLabel = `${this.model.servicosId.length} serviços selecionados`;
            } else {
                filter.servicoLabel = "Todos";
            }

            if (this.model.statusId.length === 1) {
                const status = this.form.status.find(s => s.id === this.model.statusId[0]);
                filter.statusLabel = status ? status.nome : 'Status não encontrado';
            } else if (this.model.statusId.length > 1 && this.model.statusId.length < this.form.status.length) {
                filter.statusLabel = `${this.model.statusId.length} status selecionados`;
            } else {
                filter.statusLabel = "Todos";
            }

            if (this.model.prioridadesId.length === 1) {
                const prioridade = this.form.prioridades.find(p => p.id === this.model.prioridadesId[0]);
                filter.prioridadeLabel = prioridade ? prioridade.nome : 'Prioridade não encontrada';
            } else if (this.model.prioridadesId.length > 1 && this.model.prioridadesId.length < this.form.prioridades.length) {
                filter.prioridadeLabel = `${this.model.prioridadesId.length} prioridades selecionadas`;
            } else {
                filter.prioridadeLabel = "Todas";
            }

            return this.camelObjectKeysToSnakeRecursive(filter);
        },
        getFilter() {
            if (this.model.periodo) {
                const filter = JSON.parse(JSON.stringify(this.model));
                filter.periodo.start = moment(this.model.periodo.start).format('DD/MM/YYYY');
                filter.periodo.end = moment(this.model.periodo.end).format('DD/MM/YYYY');
                return this.camelObjectKeysToSnakeRecursive(filter);
            }
            return null;
        },
        download(response) {
            const content = new Blob([response.data], {type: response.headers['content-type']})
            const link = document.createElement('a')
            const url = URL.createObjectURL(content)

            link.href = url
            link.target = '_blank'
            link.click()
            link.remove()
        },
        usuarioChange() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.grupos = []
            this.form.subgrupos = []
            this.form.servicos = []
            this.form.status = []
            this.form.prioridades = []

            this.model.unidadesId = []
            this.model.infraestruturasId = []
            this.model.gruposId = []
            this.model.subgruposId = []
            this.model.servicosId = []
            this.model.statusId = []
            this.model.prioridadesId = []

            const request = {
                listar: 'unidades',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
            }

            if (this.loadingCount === 0) {
                this.setLoading()
                this.loadingCount++
            }

            this.repositories.relatorioSolicitacoes.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    if (response.data.unidades) {
                        this.form.unidades = Object.assign(response.data.unidades)
                    }
                })
        },
        unidadeChange () {
            this.form.infraestruturas = []
            this.form.grupos = []
            this.form.subgrupos = []
            this.form.servicos = []
            this.form.status = []
            this.form.prioridades = []

            this.model.infraestruturasId = []
            this.model.gruposId = []
            this.model.subgruposId = []
            this.model.servicosId = []
            this.model.statusId = []
            this.model.prioridadesId = []

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                usuario_solicitante_id: this.model.usuarioSolicitanteId,
                unidadesId: this.model.unidadesId,
            }

            if (this.loadingCount === 0) {
                this.setLoading()
                this.loadingCount++
            }

            this.repositories.relatorioSolicitacoes.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    if (response.data.infraestruturas.length > 0) {
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    }
                })
                .catch(this.handleError)
        },
        infraestruturaChange() {
            this.form.grupos = []
            this.form.subgrupos = []
            this.form.servicos = []
            this.form.status = []
            this.form.prioridades = []

            this.model.gruposId = []
            this.model.subgruposId = []
            this.model.servicosId = []
            this.model.statusId = []
            this.model.prioridadesId = []

            const request = {
                listar: 'grupos',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                usuario_solicitante_id: this.model.usuarioSolicitanteId,
                unidadesId: this.model.unidadesId,
                infraestruturasId: this.model.infraestruturasId,
            }

            if (this.loadingCount === 0) {
                this.setLoading()
                this.loadingCount++
            }

            this.repositories.relatorioSolicitacoes.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    if (response.data.grupos.length > 0) {
                        this.form.grupos = Object.assign(response.data.grupos)
                    }
                })
                .catch(this.handleError)
        },
        grupoChange() {
            this.form.subgrupos = []
            this.form.servicos = []
            this.form.status = []
            this.form.prioridades = []

            this.model.subgruposId = []
            this.model.servicosId = []
            this.model.statusId = []
            this.model.prioridadesId = []

            const request = {
                listar: 'subgrupos',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                usuario_solicitante_id: this.model.usuarioSolicitanteId,
                unidadesId: this.model.unidadesId,
                infraestruturasId: this.model.infraestruturasId,
                gruposId: this.model.gruposId,
            }

            if (this.loadingCount === 0) {
                this.setLoading()
                this.loadingCount++
            }

            this.repositories.relatorioSolicitacoes.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    if (response.data.subgrupos.length > 0) {
                        this.form.subgrupos = Object.assign(response.data.subgrupos)
                    }
                })
                .catch(this.handleError)
        },
        subgrupoChange() {
            this.form.servicos = []
            this.form.status = []
            this.form.prioridades = []

            this.model.servicosId = []
            this.model.statusId = []
            this.model.prioridadesId = []

            const request = {
                listar: 'servicos',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                usuario_solicitante_id: this.model.usuarioSolicitanteId,
                unidadesId: this.model.unidadesId,
                infraestruturasId: this.model.infraestruturasId,
                gruposId: this.model.gruposId,
                subgruposId: this.model.subgruposId,
            }

            if (this.loadingCount === 0) {
                this.setLoading()
                this.loadingCount++
            }

            this.repositories.relatorioSolicitacoes.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    if (this.checkLength(response.data.servicos)) {
                        this.form.servicos = Object.assign(response.data.servicos)
                    }
                })
                .catch(this.handleError)
        },
        servicoChange() {
            this.form.status = []
            this.form.prioridades = []

            this.model.statusId = []
            this.model.prioridadesId = []

            const request = {
                listar: 'status',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                usuario_solicitante_id: this.model.usuarioSolicitanteId,
                unidadesId: this.model.unidadesId,
                infraestruturasId: this.model.infraestruturasId,
                gruposId: this.model.gruposId,
                subgruposId: this.model.subgruposId,
                servicosId: this.model.servicosId,
            }

            if (this.loadingCount === 0) {
                this.setLoading()
                this.loadingCount++
            }

            this.repositories.relatorioSolicitacoes.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    if (this.checkLength(response.data.status)) {
                        this.form.status = Object.assign(response.data.status)
                    }
                })
                .catch(this.handleError)
        },
        statusChange() {
            this.form.prioridades = []

            this.model.prioridadesId = []

            const request = {
                listar: 'prioridades',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                usuario_solicitante_id: this.model.usuarioSolicitanteId,
                unidadesId: this.model.unidadesId,
                infraestruturasId: this.model.infraestruturasId,
                gruposId: this.model.gruposId,
                subgruposId: this.model.subgruposId,
                servicosId: this.model.servicosId,
                statusId: this.model.statusId,
            }

            if (this.loadingCount === 0) {
                this.setLoading()
                this.loadingCount++
            }

            this.repositories.relatorioSolicitacoes.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    if (this.checkLength(response.data.prioridades)) {
                        this.form.prioridades = Object.assign(response.data.prioridades)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

            this.loadingCount = 0
        },
        checkLength(data) {
            if (data.length > 0) {
                return true
            } else {
                this.unsetLoading()
                this.loadingCount = 0
            }
        }
    },
    mixins: [error, file, repository, stringCase, debounce, object, data],
    watch: {
        'model.periodo': {
            deep: true,
            handler() {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.grupos = []
                this.form.subgrupos = []
                this.form.servicos = []
                this.form.status = []
                this.form.prioridades = []

                this.usuarioSolicitanteId = null
                this.model.unidadesId = []
                this.model.infraestruturasId = []
                this.model.gruposId = []
                this.model.subgruposId = []
                this.model.servicosId = []
                this.model.statusId = []
                this.model.prioridadesId = []

                const request = {
                    listar: 'unidades',
                    periodo: {
                        start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                        end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                    },
                }

                if (this.loadingCount === 0) {
                    this.setLoading()
                    this.loadingCount++
                }

                this.repositories.relatorioSolicitacoes.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        if (this.checkLength(response.data.unidades)) {
                            this.form.unidades = Object.assign(response.data.unidades)
                        }
                    })
                    .catch(this.handleError)
            },
        },
        'model.unidadesId': {
            handler() {
                if (this.model.unidadesId.length === 0) return;
                this.$nextTick(() => {
                    this.debounce(() => this.unidadeChange());
                });
            },
        },
        'model.infraestruturasId': {
            handler() {
                if (this.model.infraestruturasId.length === 0) return;
                this.$nextTick(() => {
                    this.debounce(() => this.infraestruturaChange());
                });
            },
        },
        'model.gruposId': {
            handler() {
                if (this.model.gruposId.length === 0) return;
                this.$nextTick(() => {
                    this.debounce(() => this.grupoChange());
                });
            },
        },
        'model.subgruposId': {
            handler() {
                if (this.model.subgruposId.length === 0) return;
                this.$nextTick(() => {
                    this.debounce(() => this.subgrupoChange());
                });
            },
        },
        'model.servicosId': {
            handler() {
                if (this.model.servicosId.length === 0) return;
                this.$nextTick(() => {
                    this.debounce(() => this.servicoChange());
                });
            },
        },
        'model.statusId': {
            handler() {
                if (this.model.statusId.length === 0) return;
                this.$nextTick(() => {
                    this.debounce(() => this.statusChange());
                });
            },
        },
        'selectedCols': function (newValue) {

            this.indeterminate = false

            if (newValue.length > 0 && newValue.length != this.cols.length) {

                this.indeterminate = true
            }
        },
    },
}
</script>